/* eslint-disable no-console */
import LZ from 'lzutf8';
import QS from 'query-string';
import Key from "../utils/Key.js";
import { FilterSourceModel } from "../../filters/index.js";
const getSettingsPath = (props, name = 'groupScreen', subSettingsPath = null) => {
  const {
    relationship: {
      path
    }
  } = props;

  // Save to User settings
  return subSettingsPath ? Key.forSettings(name, path, subSettingsPath) : Key.forSettings(name, path);
};
const EMPTY_FILTER_SOURCES = Object.freeze(FilterSourceModel.create());
const decodeQuery = (location, {
  perPage,
  viewers
}) => {
  const rtn = {
    filters: EMPTY_FILTER_SOURCES,
    viewers
  };
  const params = QS.parse(location.search);
  try {
    if (params.f) {
      const f = LZ.decompress(LZ.decodeBase64(params.f));
      rtn.filters = JSON.parse(f);
    }
  } catch (err) {
    console.error(err);
  }
  try {
    // if ( params.v ) {
    //   const v = LZ.decompress( LZ.decodeBase64( params.v ) )
    //   rtn.viewers = JSON.parse( v )
    // }
  } catch (err) {
    console.error(err);
  }
  rtn.perPage = Number(params.perPage) || perPage;
  rtn.page = Number(params.page) || 0;
  return {
    ...params,
    ...rtn
  };
};
const encodeQuery = ({
  perPage,
  page,
  filters,
  viewers,
  ...rest
}) => {
  const q = {
    ...rest
  };
  if (typeof perPage === 'number') {
    q.perPage = perPage;
  }
  if (typeof page === 'number') {
    q.page = page;
  }
  if (filters) {
    try {
      q.f = LZ.encodeBase64(LZ.compress(JSON.stringify(filters)));
    } catch (err) {
      console.error(err);
    }
  }
  // if ( viewers ) {
  //   try {
  //     q.v = LZ.encodeBase64( LZ.compress( JSON.stringify( viewers ) ) )
  //   } catch ( err ) {
  //     console.error( err )
  //   }
  // }
  return QS.stringify(q);
};
export default {
  getSettingsPath,
  decodeQuery,
  encodeQuery,
  EMPTY_FILTER_SOURCES
};